import patient1 from "../assets/patient-images/patient1.png";
import patient2 from "../assets/patient-images/patient2.png";
import patient3 from "../assets/patient-images/patient3.png";
import patient4 from "../assets/patient-images/patient4.png";
import patient5 from "../assets/patient-images/patient5.png";
import patient6 from "../assets/patient-images/patient6.png";
import patient7 from "../assets/patient-images/patient7.png";
import patient8 from "../assets/patient-images/patient8.png";
import patient9 from "../assets/patient-images/patient9.png";
import patient10 from "../assets/patient-images/patient10.png";
import patient11 from "../assets/patient-images/patient11.png";
import patient12 from "../assets/patient-images/patient12.png";
import patient13 from "../assets/patient-images/patient13.png";
import patient14 from "../assets/patient-images/patient14.png";
import patient15 from "../assets/patient-images/patient15.png";
import patient16 from "../assets/patient-images/patient16.png";
import patient17 from "../assets/patient-images/patient17.png";
import patient18 from "../assets/patient-images/patient18.png";
import patient19 from "../assets/patient-images/patient19.png";
import patient20 from "../assets/patient-images/patient20.png";
import patient21 from "../assets/patient-images/patient21.png";
import patient22 from "../assets/patient-images/patient22.png";
import patient23 from "../assets/patient-images/patient23.png";
import patient24 from "../assets/patient-images/patient24.png";
import patient25 from "../assets/patient-images/patient25.png";
import patient26 from "../assets/patient-images/patient26.png";
import patient27 from "../assets/patient-images/patient27.png";
import patient28 from "../assets/patient-images/patient28.png";
import patient29 from "../assets/patient-images/patient29.png";
import patient30 from "../assets/patient-images/patient30.png";

const imageList = [
  patient1, patient2, patient3, patient4, patient5, patient6, patient7, patient8, patient9, patient10,
  patient11, patient12, patient13, patient14, patient15, patient16, patient17, patient18, patient19, patient20,
  patient21, patient22, patient23, patient24, patient25, patient26, patient27, patient28, patient29, patient30
];

export default imageList;
